import type { DefaultTheme } from 'styled-components'

export const theme = {
  loginPage: {
    width: '400px',
    logoSize: '55px',
    logoUrl: '/logo.png'
  },
  fontColors: {
    link: '#2762FF',
    primary: '#080C18',
    secondary: '#38405A',
    tertiary: '#8C92A7',
    white: '#FFFFFF',
    success: '#11CF00',
    card_background: '#F6F9FF',
    placeholder: '#54667880',
    error: '#f25766'
  },
  fontWeights: {
    regular: 400,
    medium: 500,
    bold: 700
  },
  components: {
    input: {
      height: '40px'
    }
  }
} satisfies DefaultTheme
